module.exports = __webpack_public_path__ + "static/img/selfAdd_01.56477330.svg";